const unitKey = value => String(value ?? '').normalize('NFKC').toLowerCase().replace(/ё/g, 'е').replace(/[\s.²³]/gu, c => c === '²' ? '2' : c === '³' ? '3' : '').trim()
const groups = {
  m: ['м', 'мп', 'пм', 'погм', 'метр', 'метры', 'метров', 'метрпогонный', 'погонныйметр', 'm'],
  mm: ['мм', 'миллиметр', 'mm'], cm: ['см', 'сантиметр', 'cm'],
  m2: ['м2', 'квм', 'метрквадратный', 'm2'], m3: ['м3', 'кубм', 'метркубический', 'm3'],
  kg: ['кг', 'килограмм', 'kg'], g: ['г', 'грамм', 'g'], t: ['т', 'тонна'],
  pcs: ['шт', 'штука', 'штуки', 'штук'], l: ['л', 'литр', 'литры', 'l'],
  pair: ['пар', 'пара', 'пары', 'паров'],
}
const canonicalUnit = value => {
  const label = String(value ?? '').trim()
  const parenthesized = /^(.+?)\s*\(\s*1\s+([^()]+)\s*\)$/.exec(label)
  if (parenthesized) {
    const first = canonicalUnit(parenthesized[1]), second = canonicalUnit(parenthesized[2])
    return first && first === second ? first : null
  }
  const key = unitKey(label)
  return Object.keys(groups).find(group => groups[group].includes(key)) || null
}
const equivalentUnits = (first, second) => !!canonicalUnit(first) && canonicalUnit(first) === canonicalUnit(second)
const conversionFor = (unit, target, confirmation) => {
  if (!target) return null
  if (equivalentUnits(unit, target.unit)) return { factor: 1, source: 'equivalent' }
  if (Number.isFinite(confirmation?.factor) && confirmation.factor > 0 && confirmation.factor <= 1e9)
    return { factor: confirmation.factor, source: 'confirmed' }
  return null
}
const suggestedConversion = (unit, target) => {
  const coefficient = Number(target?.base_coefficient)
  if (target?.unit_id && target.base_unit && equivalentUnits(unit, target.base_unit)
    && Number.isFinite(coefficient) && coefficient > 0 && coefficient <= 1e9)
    return { factor: 1 / coefficient, coefficient, baseUnit: target.base_unit }
  return null
}
module.exports = { canonicalUnit, equivalentUnits, conversionFor, suggestedConversion }
